export default __webpack_public_path__ + "static/media/gestaovendas.4b30392b.svg";